// extracted by mini-css-extract-plugin
export default {"container":"style_container__xGrZe","detail":"style_detail__Dl3Rs"};